import {LOGGED_OUT_DUE_TO_INACTIVITY} from "./types";

export const setLoggedOutDueToInactivity = (state) => ({
  type: LOGGED_OUT_DUE_TO_INACTIVITY,
  payload: state,
});
